<template>
    <div>
        <div class="filter-bar">
            <el-form :inline="true" @submit.native.prevent="submitSearch">
                <el-form-item >
                    <CustomInput label="推广：">
                        <BatchMultipleSelect
                            key="batchSelectApp"
                            ref="batchSelectApp"
                            :value="tempQuery.app_id"
                            :options="appOptions"
                            :loading="appLoading"
                            :remote-method="remoteBatchListApp"
                            @change="changeBatchSearchApp"
                            @clear-all="clearBatchSearchApp"
                            @change-all="changeBatchSearchAll"
                            @batch-submit="remoteBatchSubmit"
                            @show-options="showSelectOptions"
                            title=" 推广"
                            batch-desc="输入或粘贴推广ID、内容，每行一个"
                            :clearable="true"
                            :collapse-tags="true"
                            placeholder="输入推广名称、ID、内容关键字搜索" />
                    </CustomInput>
                    
                </el-form-item>
                <el-form-item>
                    <CustomInput label="KPI维护状态：">
                        <el-select v-model="tempQuery.kpi_status" @change="submitSearch" filterable clearable placeholder="请选择" style="width: 150px;">
                            <el-option label="未维护" value="0"></el-option>
                            <el-option label="已维护" value="1"></el-option>
                        </el-select>
                    </CustomInput>
                    
                </el-form-item>


                <el-form-item  v-for="filter in filterOptions" v-if="filter.checked" :key="filter.name" class="custom-filter">
                    <CustomInput :label="filter.label+'：'" @append-click="removeFilter(filter)">
                        <ESelect v-if="filter.type=='remote-select'"
                               v-model="tempQuery[filter.name]"
                               remote
                               :remote-method="(query)=>remoteFilter(query,filter)"
                               :loading="filter.loading"
                               :multiple="!!filter.isMultiple"
                               reserve-keyword
                               collapse-tags
                               filterable clearable
                               :placeholder="filter.placeholder||'请选择'"
                               style="width: 190px;">
                            <el-option :label="option.name" :value="option.value" v-for="option in filter.options" :key="option.value"></el-option>
                        </ESelect>
                        <ESelect v-else-if="filter.type=='select'"
                                v-model="tempQuery[filter.name]"
                                :multiple="!!filter.isMultiple"
                                collapse-tags
                                filterable clearable
                                :placeholder="filter.placeholder||'请选择'"
                                :style="{width:filter.name=='yy_group_id'?'170px':'165px'}">
                            <el-option :label="option.name" :value="option.value" v-for="option in filter.options" :key="option.value"></el-option>
                        </ESelect>
                        <template #append>
                            <div class=" pointer text-color-error"  title="删除">
                                <span  >x</span>
                            </div>
                        </template>
                        
                    </CustomInput>
                    
                </el-form-item>


                <el-form-item label="" label-width="0">
                    <el-button size="mini" type="primary" @click="showFilterConfigModal" plain>+添加</el-button>
                    <el-button v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '筛选区(查询)' }" size="mini" type="primary" :loading="dataLoading" @click="submitSearch" style="width: 75px;">筛选</el-button>
                    <el-button v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '筛选区(重置筛选)' }" size="mini" @click="resetForm">重置筛选</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="data-list pr10">
            <div class="tool-bar mb10">
                <el-button v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '批量编辑' }" v-if="pageFuncNames.includes('edit')" @click="handleBatchEdit" :disabled="appSelected.length<=0" size="mini" class="ml10" type="primary" plain>批量编辑</el-button>
                <el-button v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '批量导入' }" v-if="pageFuncNames.includes('batch_import')" @click="handleBatchImport" size="mini" class="ml10" type="primary" plain>批量导入</el-button>
                <el-button v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '导出' }" v-if="pageFuncNames.includes('export')" size="mini" :loading="exportLoading" @click="exportData" style="width:75px;">导出</el-button>
                <el-button v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '自定义列' }" size="mini" @click="showCustomFieldModal" style="padding: 5px;" title="自定义字段">
                    <span class="ver-middle icon iconfont icon-jt-liebiaoshezhi-2" ></span>
                </el-button>
            </div>
            <JtTable
                v-loading="dataLoading||columnLoading"
                :data="dataList"
                stripe
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :default-sort = "{prop: 'log_time', order: 'descending'}"
                @selection-change="appSelectionChange"
                style="width: 100%">
                <el-table-column
                    fixed
                    type="selection"
                    align="center"
                    width="60">
                </el-table-column>
                <el-table-column
                    fixed
                    prop="index"
                    align="center"
                    label="序号"
                    width="60">
                </el-table-column>
                <el-table-column
                    fixed
                    prop="app_name"
                    label="推广名称"
                    width="150"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    fixed
                    prop="action"
                    label="操作"
                    align="center"
                    width="80">
                    <template slot-scope="scope">
                       <div class="text-color-primary">
                           <span v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '列表(产品详情)' }" title="产品详情" v-if="pageFuncNames.includes('get_detail')" class="action-btn pointer icon iconfont icon-jt-shujuchakan-05" @click="showDetailDrawer(scope.row)"></span>
                           <span v-matomo="{behaviorCategory: `产品KPI管理(${platName})`,  name: '列表(编辑)' }" title="编辑产品KPI" v-if="pageFuncNames.includes('edit')" class="action-btn pointer icon iconfont icon-jt-bianji" @click="showEditModal(scope.row)" ></span>
                       </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="delivery_type_text"
                    label="投放类型"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="delivery_scene_text"
                    label="kpi维度（场景）"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="app_kpi_status_text"
                    label="KPI维护状态"
                    width="120">
                    <template slot-scope="scope">
                        <span :class="scope.row.app_kpi_status_text=='未维护'?'text-color-error':''">{{scope.row.app_kpi_status_text||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-for="(field,index) in columns"
                    :key="field.field+'-'+index"
                    :prop="field.field"
                    :label="field.name"
                    show-overflow-tooltip
                    :width="field.field=='package_name'?250:135"
                    :min-width="field.field=='package_name'?250:135"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row[field.field]||'--'}}</span>
                    </template>
                </el-table-column>
            </JtTable>
        </div>
        <div class="page-bar tac mt20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[10, 30,50,100]"
                :page-size="queryData.rn"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCnt">
            </el-pagination>
        </div>
        <FilterConfigModal ref="filterConfigModal" :list="filterOptions" @save="updateFilter"/>
        <CustomFieldModal ref="customFieldModal" :config="fieldConfig" :field-type="curFieldType" :select-list="userFields" @save="updateFields" />
        <EditKpiModal ref="editKpiModal" :config="kpiFieldConfig" :modal-data="actionRow" :plat-id="platId" :is-last-row="isLastRow" @next="getNextApp" @update="updateSubpackage"/>
        <BatchKpiModal ref="batchKpiModal" :config="kpiFieldConfig" :modal-data="appSelected" :plat-id="platId" @update="getDataList"/>
        <AppDetailDrawer ref="appDetailDrawer" :app-data="actionRow" :plat-id="platId" />
    </div>
</template>

<script>

    import API from '@/api/dataCenter/appKpi.js';
    import FilterConfigModal from '../modal/filterConfigModal';
    import CustomFieldModal from '../modal/customFieldModal';
    import EditKpiModal from '../modal/editKpiModal';
    import BatchKpiModal from '../modal/batchKpiModal';
    import AppDetailDrawer from '../drawer/appDetailDrawer';
    import util from '@/libs/utils';
    import { batchImportModal } from '../modal';
    import BatchMultipleSelect from '@/components/BatchMultipleSelect';

    export default {
        name: "ListPage",
        props:{
            platId:[String,Number],
            pageFuncNames:Array,
            platName:String,
        },
        components:{
            FilterConfigModal,
            CustomFieldModal,
            EditKpiModal,
            BatchKpiModal,
            AppDetailDrawer,
            BatchMultipleSelect,
        },
        data(){
            return {
                queryData: {
                    app_id:[],
                    kpi_status:'',
                    bloc_name:[],
                    subproject_tag10:[],
                    yy_id:[],
                    xs_id:[],
                    yy_group_id:[],
                    income_type:[],
                    subpackage_type:[],
                    delivery_type:[],
                    delivery_scene:[],
                    package_type:[],
                    game_classify:[],
                    pn: 1,
                    rn: 30,
                },
                tempQuery:{
                    app_id:[],
                    kpi_status:'',
                    bloc_name:[],
                    subproject_tag10:[],
                    yy_id:[],
                    xs_id:[],
                    yy_group_id:[],
                    income_type:[],
                    subpackage_type:[],
                    delivery_type:[],
                    delivery_scene:[],
                    package_type:[],
                    game_classify:[],
                },
                filterOptions:[
                    {
                        label:'集团名称',
                        name:'bloc_name',
                        type:'remote-select',
                        isMultiple:true,
                        options:[],
                        placeholder:'关键字搜索,多选',
                        checked:false,
                        loading:false,
                    },
                    {
                        label:'开发者主体',
                        name:'subproject_tag10',
                        type:'remote-select',
                        isMultiple:true,
                        options:[{
                            name:'未分配',
                            value:'0',
                        }],
                        placeholder:'关键字搜索,多选',
                        checked:false,
                        loading:false,
                    },
                    {
                        label:'收益类型',
                        name:'income_type',
                        type:'select',
                        isMultiple:true,
                        options:[
                            {
                                name:'仅内购',
                                value:'1',
                            },
                            {
                                name:'仅变现',
                                value:'2',
                            },
                            {
                                name:'内购+变现',
                                value:'3',
                            },
                            {
                                name:'未分配',
                                value:'0',
                            },
                        ],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'运营组',
                        name:'yy_group_id',
                        type:'select',
                        isMultiple:true,
                        options:[],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'运营负责人',
                        name:'yy_id',
                        type:'select',
                        isMultiple:true,
                        options:[],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'销售负责人',
                        name:'xs_id',
                        type:'select',
                        isMultiple:true,
                        options:[],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'投放类型',
                        name:'delivery_type',
                        type:'select',
                        isMultiple:true,
                        options:[
                            {
                                name:'整体',
                                value:'1',
                            },
                            {
                                name:'商店',
                                value:'2',
                            },
                            {
                                name:'非商店',
                                value:'3',
                            },
                        ],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'kpi维度（场景）',
                        name:'delivery_scene',
                        type:'select',
                        isMultiple:true,
                        options:[
                            {
                                name:'整体',
                                value:'1',
                            },
                            {
                                name:'商店-整体',
                                value:'2',
                            },
                            {
                                name:'非商店-整体',
                                value:'3',
                            },
                            {
                                name:'信息流',
                                value:'4',
                            },
                            {
                                name:'联盟',
                                value:'5',
                            },
                        ],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'包体类型',
                        name:'package_type',
                        type:'select',
                        isMultiple:true,
                        options:[
                            {
                                name:'应用',
                                value:'1',
                            },
                            {
                                name:'快应用',
                                value:'2',
                            },
                            {
                                name:'未分配',
                                value:'0',
                            },
                        ],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'游戏分类',
                        name:'game_classify',
                        type:'select',
                        isMultiple:true,
                        options:[
                            {
                                name:'IAA',
                                value:'3',
                            },
                            {
                                name:'IAP',
                                value:'4',
                            },
                            {
                                name:'未分配',
                                value:'0',
                            },
                        ],
                        placeholder:'',
                        checked:false,
                    },
                    {
                        label:'分包类型',
                        name:'subpackage_type',
                        type:'select',
                        isMultiple:true,
                        options:[
                            {
                                name:'分包',
                                value:'1',
                            },
                            {
                                name:'联运包',
                                value:'2',
                            },
                            {
                                name:'官包',
                                value:'3',
                            },
                            {
                                name:'未分配',
                                value:'0',
                            },
                        ],
                        placeholder:'',
                        checked:false,
                    },
                ],
                dataLoading:false,
                columnLoading:false,
                dataList:[],
                columns:[],
                totalCnt:0,
                exportLoading:false,
                fieldConfig:[],     // 自定义字段-所有
                userFields:[],      // 用户保存的自定义字段
                actionRow:{},
                isLastRow:false,
                appSelected:[],
                appOptions:[],
                appLoading:false,
                allAppOptions:[],
            }
        },
        computed:{
            curFilterType(){
                if(this.platId=='1') return 'app_kpi_manage_filter_oppo';
                if(this.platId=='3') return 'app_kpi_manage_filter_vivo';
                if(this.platId=='4') return 'app_kpi_manage_filter_huawei';
                if(this.platId=='7') return 'app_kpi_manage_filter_mi';
            },
            curFieldType(){
                if(this.platId=='1') return 'app_kpi_manage_oppo';
                if(this.platId=='3') return 'app_kpi_manage_vivo';
                if(this.platId=='4') return 'app_kpi_manage_huawei';
                if(this.platId=='7') return 'app_kpi_manage_mi';
            },
            allFields(){
                let list = [];
                let fieldConfig = this.fieldConfig||[];
                fieldConfig.forEach(item=>{
                    list = list.concat(item.children||[]);
                });
                return list;
            },
            kpiFieldConfig(){
                /* kpi指标里 需要过滤掉包体类型、游戏分类、产品包名、开发者主体*/
                return (this.fieldConfig||[]).map(item=>{
                    let children = (item.children||[]).filter(inner=>{
                        return inner.id!='package_type'&&inner.id!='game_classify'&&inner.id!='package_name'&&inner.id!='subproject_tag10';
                    });
                    return {
                        checked:item.checked,
                        config:item.config,
                        disabled:item.disabled,
                        display_name:item.display_name,
                        id:item.id,
                        pid:item.pid,
                        children:children.map(inner=>{
                            return {
                                checked:inner.checked,
                                config:inner.config,
                                disabled:inner.disabled,
                                display_name:inner.display_name,
                                id:inner.id,
                                pid:inner.pid,
                            }
                        })
                    };
                })
            }
        },
        mounted(){
            if(this.platId=='3'){
                let deliveryFilter = this.filterOptions.find(item=>item.name=='delivery_scene');
                if(deliveryFilter){
                    let deliveryOptions = deliveryFilter.options||[];
                    if(!deliveryOptions.find(item=>item.value=='6')){
                        deliveryOptions.push({
                            name:'智能投放',
                            value:'6',
                        })
                    }
                }

            }
            this.getCustomFilter();
            this.getSearchOptions();
            this.getCustomField();

            let routeQuery = this.$route.query||{};
            if(routeQuery.query_app){
                let conditionId = routeQuery.query_app;
                let appListStr = localStorage.getItem("intelligentRuleApp_"+conditionId);
                if(appListStr){
                    let appList = JSON.parse(appListStr);
                    let appIdArr = Array.isArray(appList)?appList:[appList];
                    this.tempQuery.app_id = appIdArr;
                    localStorage.removeItem("intelligentRuleApp_"+conditionId);
                }
            }
            this.submitSearch();
        },
        methods:{
            remoteBatchListApp(query){
                console.log('remoteBatchListApp',query);
                if (query !== '') {
                    this.appLoading = true;
                    API.getSearchOptions({
                        plat_id:this.platId,
                        search:query,
                        search_type:'app',
                    }).then(res=>{
                        let resData = res.data||{};
                        let resList = resData.list||[];
                        this.appLoading = false;
                        this.appOptions = resList.map(item=>{
                            return {
                                name:item.name,
                                value:item.id,
                            }
                        });
                        this.appOptions.forEach(item=>{
                            if(!this.allAppOptions.find(inner=>inner.value==item.value&&inner.name==item.name)){
                                this.allAppOptions.push({...item});
                            }
                        })
                    },err=>{
                        this.appLoading = false;
                        console.log('remoteBatchListApp err',err);
                        this.appOptions = [];
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false,
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                    })
                } else {
                    this.appOptions = [];
                }
            },
            changeBatchSearchApp(val){
                console.log('changeBatchSearchApp',val);
                this.$set(this.tempQuery,'app_id',[...val]);
            },
            clearBatchSearchApp(val=[]){
                val.forEach(item=>{
                    let index = this.tempQuery.app_id.findIndex(inner=>inner==item);
                    if(index!=-1){
                        this.tempQuery.app_id.splice(index,1);
                    }
                })
            },
            changeBatchSearchAll(val){
                console.log('changeBatchSearchAll',val);
                let oldVal = this.tempQuery.app_id;
                let newVal = [...val].filter(item=>!oldVal.includes(item));
                this.$set(this.tempQuery,'app_id',oldVal.concat(newVal));
            },
            remoteBatchSubmit(con){
                console.log('remoteBatchSubmit',con);
                if(!con) return;
                API.getSearchOptions({
                    plat_id:this.platId,
                    search:'',
                    search_type:'app',
                    batch_search:con,
                }).then(res=>{
                    let $refSelect = this.$refs.batchSelectApp;
                    $refSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            $refSelect.hideBatchModal();

                            let idList = this.appOptions.map(item=>item.value);
                            (successList||[]).forEach(item=>{
                                if(!idList.includes(item.id)){
                                    this.appOptions.push({
                                        name:item.name,
                                        value:item.id,
                                    });
                                    if(!this.allAppOptions.find(inner=>inner.value==item.value&&inner.name==item.name)){
                                        this.allAppOptions.push({...item});
                                    }
                                }
                                if(!this.tempQuery.app_id.includes(item.id)){
                                    this.tempQuery.app_id.push(item.id);
                                }
                            })
                        });
                    }else{

                        $refSelect.hideBatchModal();
                        let idList = this.appOptions.map(item=>item.value);
                        (successList||[]).forEach(item=>{
                            if(!idList.includes(item.id)){
                                this.appOptions.push({
                                    name:item.name,
                                    value:item.id,
                                });
                                if(!this.allAppOptions.find(inner=>inner.name==item.name&&inner.value==item.value)){
                                    this.allAppOptions.push({...item});
                                }
                            }
                            if(!this.tempQuery.app_id.includes(item.id)){
                                this.tempQuery.app_id.push(item.id);
                            }
                        })
                    }
                },err=>{
                    console.log('batch error', err);
                    let $refSelect = this.$refs.batchSelectApp;
                    $refSelect.hideBatchLoading();
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求有误');
                })
            },
            showSelectOptions(){
                let value = this.tempQuery.app_id||[];
                this.appOptions = value.map(item=>{
                    let actionItem = this.allAppOptions.find(inner=>inner.value==item||inner.id==item);
                    return {
                        name:actionItem?actionItem.name:item,
                        value:item,
                    }
                })
            },
            submitSearch(){
                this.queryData.pn = 1;
                this.queryData.app_id = this.tempQuery.app_id;
                this.queryData.kpi_status = this.tempQuery.kpi_status;
                this.queryData.bloc_name = this.tempQuery.bloc_name;
                this.queryData.yy_id = this.tempQuery.yy_id;
                this.queryData.xs_id = this.tempQuery.xs_id;
                this.queryData.yy_group_id = this.tempQuery.yy_group_id;
                this.queryData.income_type = this.tempQuery.income_type;
                this.queryData.delivery_type = this.tempQuery.delivery_type;
                this.queryData.delivery_scene = this.tempQuery.delivery_scene;
                this.queryData.subpackage_type = this.tempQuery.subpackage_type;
                this.queryData.game_classify = this.tempQuery.game_classify;
				this.queryData.package_type = this.tempQuery.package_type;
				this.queryData.subproject_tag10 = this.tempQuery.subproject_tag10;
                this.getDataList();
            },
            resetForm(){
                this.tempQuery.app_id = [];
                this.tempQuery.kpi_status = [];
                this.tempQuery.bloc_name = [];
                this.tempQuery.subproject_tag10 = [];
                this.tempQuery.yy_id = [];
                this.tempQuery.xs_id = [];
                this.tempQuery.yy_group_id = [];
                this.tempQuery.income_type = [];
                this.tempQuery.subpackage_type = [];
                this.tempQuery.delivery_type = [];
                this.tempQuery.delivery_scene = [];
                this.tempQuery.package_type = [];
                this.tempQuery.game_classify = [];
                this.submitSearch();
            },

            showFilterConfigModal(){
                this.$refs.filterConfigModal.showModal();
            },
            showCustomFieldModal(){
                this.$refs.customFieldModal.showModal();
            },
            updateFilter(list){
                this.filterOptions.forEach(item=>{
                    if(list.includes(item.name)){
                        item.checked = true;
                    }else{
                        item.checked = false;
                        this.tempQuery[item.name] = [];
                    }
                });
                API.setCustomFilter({
                    field_type:this.curFilterType,
                    filters:list.map(item=>{
                        let actionItem = this.filterOptions.find(inner=>inner.name==item)||{};
                        return {
                            name:item,
                            label:actionItem.label,
                        }
                    }),
                });
            },
            removeFilter(filter){
                this.tempQuery[filter.name] = [];
                let actionFilter = this.filterOptions.find(item=>item.name==filter.name);
                if(actionFilter){
                    actionFilter.checked = false;
                }
                API.setCustomFilter({
                    field_type:this.curFilterType,
                    filters:this.filterOptions.filter(item=>item.checked).map(item=>{
                        return {
                            name:item.name,
                            label:item.label,
                        }
                    }),
                });
            },
            getCustomFilter(){
                API.getCustomFilter({
                    field_type:this.curFilterType,
                }).then(res => {
                    let resData = res.data || [];
                    this.filterOptions.forEach(item=>{
                        item.checked = resData.includes(item.name);
                    });
                }, (err) => {
                    console.log('getCustomFilter error', err);
                });
            },
            getSearchOptions(){
                ['yy_id','xs_id','yy_group_id','subpackage_type','income_type','game_classify','package_type'].forEach(filter=>{
                    API.getSearchOptions({
                        search_type:filter,
                        plat_id:this.platId,
                    }).then(res => {
                        let resData = (res.data||{}).list || [];
                        let filterItem = this.filterOptions.find(item=>item.name==filter);
                        if(filterItem){
                            let options = resData.map(item=>{
                                return {
                                    name:item.name,
                                    value:item.id,
                                }
                            });
                            this.$set(filterItem,'options',options);
                        }
                    });
                })
            },
            remoteFilter(query,filter){
                let filterItem = this.filterOptions.find(item=>item.name==filter.name);
                if(!filterItem) return;
                if(!query){
                    return filterItem.options = [];
                }
                filterItem.loading = true;
                API.getSearchOptions({
                    search:query,
                    search_type:filter.name,
                    plat_id:this.platId,
                }).then(res => {
                    let resData = (res.data||{}).list || [];
                    filterItem.loading = false;
                    let options = resData.map(item=>{
                        return {
                            name:item.name,
                            value:item.id,
                        }
                    });
                    if(filter.name=='subproject_tag10'){
                        filterItem.options = [].concat(options);
                    }else{
                        filterItem.options = options;
                    }

                },err=>{
                    console.log('getSearchOptions err',err);
                    filterItem.loading = false;
                    filterItem.options = filter.name=='subproject_tag10'?[]:[];
                });
            },
            getCustomField(){
                API.getCustomField({
                    field_type:this.curFieldType,
                }).then(res => {
                    let resData = res.data || [];
                    this.fieldConfig = resData.field||[];
                    this.userFields = resData.user_field||[];
                    this.$nextTick(()=>{
                        this.makeColumns();
                    })
                },err=>{
                    console.log('getCustomField err',err);
                    this.fieldConfig = [];
                    this.userFields = [];
                });
            },
            makeColumns(){
                this.columnLoading = true;
                this.columns = this.userFields.map(item=>{
                    let colItem = this.allFields.find(field=>field.id==item)||{};
                    return {
                        field:colItem.id,
                        name:colItem.display_name,
                    }
                });
                this.columnLoading = false;
            },
            updateFields(list){
                this.userFields = (list||[]).map(item=>item.id);
                this.fieldConfig.forEach(group=>{
                    let children = group.children||[];
                    children.forEach(child=>{
                        child.checked = this.userFields.includes(child.id);
                    })
                });
                this.makeColumns();
            },
            exportData(){
                this.exportLoading = true;
                API.getDataList({
                    export:'1',
                    plat_id:this.platId,
                    app_id:this.queryData.app_id,
                    kpi_status:this.queryData.kpi_status,
                    bloc_name:this.queryData.bloc_name,
                    subproject_tag10:this.queryData.subproject_tag10,
                    yy_id:this.queryData.yy_id,
                    xs_id:this.queryData.xs_id,
                    yy_group_id:this.queryData.yy_group_id,
                    income_type:this.queryData.income_type,
                    delivery_type:this.queryData.delivery_type,
                    delivery_scene:this.queryData.delivery_scene,
                    subpackage_type:this.queryData.subpackage_type,
                    package_type:this.queryData.package_type,
                    game_classify:this.queryData.game_classify,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    this.exportLoading = false;
                    this.$message.success(res.info||'操作成功');

                }, (err) => {
                    console.log('exportData error', err);
                    this.exportLoading = false;
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            message: errData.join('；'),
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
            getDataList(){
                this.dataLoading = true;
                this.appSelected = [];
                API.getDataList({
                    plat_id:this.platId,
                    app_id:this.queryData.app_id,
                    kpi_status:this.queryData.kpi_status,
                    bloc_name:this.queryData.bloc_name,
                    subproject_tag10:this.queryData.subproject_tag10,
                    yy_id:this.queryData.yy_id,
                    xs_id:this.queryData.xs_id,
                    yy_group_id:this.queryData.yy_group_id,
                    income_type:this.queryData.income_type,
                    delivery_type:this.queryData.delivery_type,
                    delivery_scene:this.queryData.delivery_scene,
                    subpackage_type:this.queryData.subpackage_type,
                    package_type:this.queryData.package_type,
                    game_classify:this.queryData.game_classify,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;

                    let baseIndex = this.queryData.rn * (this.queryData.pn-1);
                    this.dataList = (resData.list || []).map((item,index)=>{
                        item.index = baseIndex+index+1;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;

                    this.makeColumns();
                }, (err) => {
                    console.log('getDataList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            handleBatchEdit(){
                let noGameClassifyApp = [];
                this.appSelected.forEach(item=>{
                    if(!item.game_classify||item.game_classify=='未分配'){
                        if(!noGameClassifyApp.find(inner=>inner.app_name==item.app_name)){
                            noGameClassifyApp.push(item);
                        }
                    }
                });
                if(noGameClassifyApp.length>0){
                    let tipMsg = this.$confirm(`<p class="text-color-error">您要编辑的 ${noGameClassifyApp.map(item=>item.app_name).join('、')} 产品游戏分类未分配，请配置后重试</p>`, `游戏分类未分配`, {
                        dangerouslyUseHTMLString:true,
                        confirmButtonText: '立即配置',
                        cancelButtonText: '取消',
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type: 'warning'
                    }).then(() => {
                        let $router= this.$router.resolve({
                            name:'app_management_page',
                            query:{
                                plat_id:this.platId,
                                subproject_id:noGameClassifyApp.map(item=>item.app_id),
                            },
                        });
                        window.open($router.href, '_blank');
                        tipMsg.close();
                    }).catch(() => {
                    });
                    return false;
                }

                let selectGameClassify = this.appSelected.map(item=>item.game_classify);
                if(selectGameClassify.some(item=>item=='iaa'||item=='IAA')&&selectGameClassify.some(item=>item=='iap'||item=='IAP')){
                    this.$confirm(`<p class="text-color-error">您要批量编辑的产品包含多种游戏分类，为避免错误编辑，请只选一种游戏分类后重试！</p>`, '游戏分类不一致', {
                        cancelButtonText: '关闭',
                        showConfirmButton:false,
                        dangerouslyUseHTMLString:true,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                    });
                    return false;
                }

                this.$refs.batchKpiModal.showModal();
            },
            handleBatchImport(){
                console.log('handleBatchImport');

                batchImportModal({
                    props: {
                        platId:this.platId,
                        config:this.fieldConfig,
                    },
                    cbs: {
                        onSubmit:()=>{
                            console.log('batchImport onSubmit');
                            this.getDataList();
                        },
                    },
                })
            },
            showEditModal(row){
                console.log('edit row',row);
                this.actionRow = util.deepClone(row);
                let actionRowIndex = this.dataList.findIndex(item=>item.index==row.index);
                if(row.game_classify==''||row.game_classify=='未分配'){
                    let tipMsg = this.$confirm(`<p class="text-color-error">您要编辑的 ${row.app_name} 产品游戏分类未分配，请配置后重试</p>`, `游戏分类未分配`, {
                        dangerouslyUseHTMLString:true,
                        confirmButtonText: '立即配置',
                        cancelButtonText: '取消',
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type: 'warning'
                    }).then(() => {
                        let $router= this.$router.resolve({
                            name:'app_management_page',
                            query:{
                                plat_id:this.platId,
                                subproject_id:[row.app_id],
                            },
                        });
                        window.open($router.href, '_blank');
                        tipMsg.close();
                    }).catch(() => {
                    });
                    return false;
                }

                this.isLastRow = actionRowIndex>0&&(actionRowIndex==this.dataList.length-1);
                this.$refs.editKpiModal.showModal();
            },
            getNextApp(){
                let actionRowIndex = this.dataList.findIndex(item=>item.index==this.actionRow.index);
                let nextRow = this.dataList[actionRowIndex+1];
                if(!nextRow) return this.$message.error('没有下一行了');
                this.showEditModal(nextRow);
            },
            updateSubpackage(formData,appData){
                // 更新同app的包类型
                let subpackageType = formData.subpackage_type;
                this.dataList.forEach(item=>{
                    if(item.app_id==this.actionRow.app_id){
                        item.subpackage_type = subpackageType=='1'?'分包':subpackageType=='2'?'联运包':subpackageType=='3'?'官包':'-';
                    }
                });

                // 更新表格中该行数据
                let actionApp = this.dataList.find(item=>item.app_id==appData.app_id&&item.delivery_scene==appData.delivery_scene&&item.delivery_type==appData.delivery_type);
                if(actionApp){
                    let fields = Object.keys(formData);
                    fields.forEach(item=>{
                        if(item!='subpackage_type'){
                            this.$set(actionApp,item,formData[item]);
                        }
                    });
                    this.$set(actionApp,'app_kpi_status','1');
                    this.$set(actionApp,'app_kpi_status_text','已维护');
                }
            },
            showDetailDrawer(row){
                this.actionRow = util.deepClone(row);
                this.$refs.appDetailDrawer.showDrawer();
            },
            appSelectionChange(val){
                this.appSelected = val.map(item => item);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar{
        background-color: #f8f8f9;
        padding: 20px 20px 0;
        border-radius: 5px;
        margin-bottom: 20px;
        ::v-deep .custom-filter .el-input{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            .el-input__inner{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .remove-btn{
            display: inline-block;
            background-color: #FFF;
            border: 1px solid #DCDFE6;
            border-left: none;
            width: 20px;
            text-align: center;
            border-radius: 0 4px 4px 0;
            position: relative;
            z-index: 1;
            height: 32px;
            line-height: 32px;
            top: 2px;
        }

        ::v-deep .custom-filter .el-select__tags-text{
            max-width: 50px;
        }
    }

    .ver-middle{
        vertical-align: -2px;
    }
    .action-btn{
        font-size: 20px;
        padding: 0 2px;
    }

    ::v-deep .data-list td.el-table__cell{
        padding: 4px 0;
    }


</style>
